module.exports = __webpack_public_path__ + "img/7.b06e7206.png";